(function (jq, dell) {
    dell.Components = dell.Components || {};
    dell.Components.DetectProduct = dell.Components.DetectProduct || {};
    (function () {
        var detectProductContent = {};

        this.enableDetectMyProduct = windowsOSValidationHelper.enableDetectMyProduct();

        this.detectProductPromise = $.Deferred();

        this.getnoSupportAssistHtml = (response) => {
            let noSupportAssistHtml = `<div class="d-none flex-column align-items-start js-unable-to-detect"><div class="d-flex align-items-center w-100 mb-3"><div class="mr-7">
                                        <svg class="dti dti-ill mr-1"><svg id="es-ill-diagnostics-info" viewBox="0 0 38 32" width="100%" height="100%">
                                                <path fill="#e5ecf2" style="fill: var(--color1, #e5ecf2)" d="M5.5 9.5h15c3.038 0 5.5 2.462 5.5 5.5s-2.462 5.5-5.5 5.5h-15c-3.038 0-5.5-2.462-5.5-5.5s2.462-5.5 5.5-5.5z"></path>
                                                <path fill="#e5ecf2" style="fill: var(--color1, #e5ecf2)" d="M22 23.5h12c2.209 0 4 1.791 4 4s-1.791 4-4 4h-12c-2.209 0-4-1.791-4-4s1.791-4 4-4z"></path>
                                                <path fill="#fff" style="fill: var(--color2, #fff)" d="M10.029 12c0-0.276 0.224-0.5 0.5-0.5h17c0.276 0 0.5 0.224 0.5 0.5v17c0 0.276-0.224 0.5-0.5 0.5h-17c-0.276 0-0.5-0.224-0.5-0.5v-17z"></path>
                                                <path fill="#003159" style="fill: var(--color3, #003159)" d="M10.529 10.5h17c0.828 0 1.5 0.672 1.5 1.5v17c0 0.828-0.672 1.5-1.5 1.5h-17c-0.828 0-1.5-0.672-1.5-1.5v-17c0-0.828 0.672-1.5 1.5-1.5zM10.529 11.5c-0.276 0-0.5 0.224-0.5 0.5v17c0 0.276 0.224 0.5 0.5 0.5h17c0.276 0 0.5-0.224 0.5-0.5v-17c0-0.276-0.224-0.5-0.5-0.5h-17z"></path>
                                                <path fill="#003159" style="fill: var(--color3, #003159)" d="M17.448 13.824c0.223 0.003 0.417 0.153 0.476 0.368l2.972 10.896 1.36-4.726c0.062-0.214 0.258-0.362 0.48-0.362h5.559v1h-5.182l-1.749 6.079c-0.062 0.215-0.26 0.363-0.484 0.362s-0.42-0.152-0.479-0.368l-2.982-10.933-1.351 4.504c-0.063 0.211-0.258 0.356-0.479 0.356h-6.088v-1h5.716l1.746-5.82c0.064-0.214 0.262-0.359 0.485-0.356z"></path>
                                                <path fill="#00447c" style="fill: var(--color4, #00447c)" d="M38 8.5c0 4.418-3.582 8-8 8s-8-3.582-8-8c0-4.418 3.582-8 8-8s8 3.582 8 8z"></path>
                                                <path fill="#fff" style="fill: var(--color2, #fff)" d="M27.895 6.925c-0.372 0-0.633-0.228-0.66-0.694s0.411-1.234 0.651-1.535c0.24-0.301 0.516-0.431 0.86-0.567 0.347-0.137 0.751-0.198 1.209-0.198 0.398 0 0.769 0.051 1.112 0.165 0.332 0.104 0.625 0.26 0.866 0.46 0.244 0.202 0.433 0.455 0.579 0.746l0.002 0.005c0.138 0.307 0.2 0.643 0.2 1.016 0 0.305-0.030 0.586-0.094 0.81-0.063 0.22-0.157 0.428-0.261 0.606l-0.003 0.005c-0.112 0.174-0.236 0.339-0.382 0.495-0.002 0.002-0.004 0.004-0.006 0.006l-0.016 0.015c-0.144 0.135-0.301 0.281-0.476 0.427-0.188 0.159-0.336 0.286-0.453 0.394-0.112 0.103-0.205 0.205-0.278 0.304-0.066 0.114-0.117 0.219-0.142 0.328-0.080 0.347-0.353 0.674-0.751 0.674h-0.017c-0.395 0-0.732-0.323-0.691-0.733 0.006-0.061 0.013-0.118 0.021-0.167 0.032-0.203 0.096-0.383 0.168-0.548 0.001-0.003 0.003-0.006 0.004-0.009 0.084-0.156 0.187-0.312 0.3-0.456l0.003-0.004c0.126-0.146 0.29-0.301 0.472-0.452 0.151-0.126 0.287-0.244 0.416-0.356l0.069-0.060c0.145-0.126 0.268-0.249 0.361-0.37 0.091-0.118 0.163-0.254 0.209-0.399l0.002-0.007c0.053-0.142 0.081-0.306 0.081-0.513 0-0.138-0.018-0.273-0.062-0.395s-0.113-0.236-0.209-0.331c-0.094-0.094-0.226-0.175-0.394-0.24-0.158-0.062-0.37-0.091-0.631-0.091-0.521 0-0.848 0.136-1.012 0.365l-0.002 0.002c-0.101 0.135-0.186 0.336-0.237 0.57-0.081 0.375-0.386 0.733-0.809 0.733z"></path>
                                                <path fill="#fff" style="fill: var(--color2, #fff)" d="M29.813 13.125c0.449 0 0.813-0.364 0.813-0.813s-0.364-0.813-0.813-0.813c-0.449 0-0.813 0.364-0.813 0.813s0.364 0.813 0.813 0.813z"></path>
                                            </svg></svg></div><p class="mb-0">${response.supportAssistText}</p></div><button class="btn btn-sm btn-outline-primary align-self-center" onclick="Dell.Components.DetectProduct.onDownloadInstallSaClick()" id="btnSupportAssist">${response.downloadInstallSaText}</button></div>`;
            this.renderView(noSupportAssistHtml);
            $('.js-product-skeleton').remove();
            $('.js-unable-to-detect').removeClass('d-none').addClass('d-flex');
            $('.js-progress-container').hide();
            $('.js-progress-label').hide();
        };

        this.getOsNotSupportedtHtml = (response) => {
            let osNotSupportedtHtml = `<div class="alert alert-primary align-items-left mt-1" role="alert" id="notSupportedOS"><span class="info-icon">
                    <svg class="dti drivers-info fill-primary mr-2"><svg viewBox="0 0 28 28"><path d="M13.9993 0.666016C6.63935 0.666016 0.666016 6.63935 0.666016 13.9993C0.666016 21.3593 6.63935 27.3327 13.9993 27.3327C21.3593 27.3327 27.3327 21.3593 27.3327 13.9993C27.3327 6.63935 21.3593 0.666016 13.9993 0.666016ZM15.3327 20.666H12.666V12.666H15.3327V20.666ZM15.3327 9.99935H12.666V7.33268H15.3327V9.99935Z" fill="#006BBD"></path></svg></svg></span>
                <span>${response.osNotSupported}</span></div>`;
            this.renderView(osNotSupportedtHtml);
            $('.js-product-skeleton').remove();
            $('.js-unable-to-detect').removeClass('d-none').addClass('d-flex');
            $('.js-progress-container').hide();
            $('.js-progress-label').hide();
        };

        this.getProductInfoHtml = (response) => {
            let productInfoHtml = `<div class="d-none align-items-center js-detected-product mb-10"><div class="product-image mr-1"><a href="${response.detectProductContent.serviceTagTargetUrl}" onclick="Dell.Components.DetectProduct.detectPcCallBack('${response.productInfo.serviceTag}','${response.productInfo.encryptedTag}');"><img class="img-fluid mt-3 mr-2" style="max-width: 90px;height: auto;" src="${response.productInfo.imageUrl}" title="${response.productInfo.name}" /></a></div>
                                <div><a href="${response.detectProductContent.serviceTagTargetUrl}" onclick="Dell.Components.DetectProduct.detectPcCallBack('${response.productInfo.serviceTag}','${response.productInfo.encryptedTag}');">${response.productInfo.name}</a><p class="text-graphite mb-0">${response.detectProductContent.serviceTag} ${response.productInfo.serviceTag}</p></div></div>`;
            this.renderView(productInfoHtml);
            $('.js-product-skeleton').remove();
            $('.js-detected-product').removeClass('d-none').addClass('d-flex');
            $('.js-progress-container').hide();
            $('.js-progress-label').hide();
            this.supportAssistFinish();
        };

        this.onDownloadInstallSaClick = () => {
            if (eval("typeof window.DownloadInstallClickCallBack") !== "undefined") {
                let callBackFun = eval("window.DownloadInstallClickCallBack");
                let returnObj = callBackFun.call(this, null);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.onDetectProductNextClick = () => {
            if (eval("typeof window.DetectProductNextClickCallBack") !== "undefined") {
                let callBackFun = eval("window.DetectProductNextClickCallBack");
                let returnObj = callBackFun.call(this, null);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };
        this.detectPcCallBack = (serviceTag, encryptedTag) => {
            if (eval("typeof window.DetectProductCallBack") !== "undefined") {
                let callBackFun = eval("window.DetectProductCallBack");
                let data = {
                    "serviceTag": serviceTag,
                    "encryptedTag": encryptedTag
                };
                let returnObj = callBackFun.call(this, data);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.supportAssistStart = () => {
            if (eval("typeof window.SupportAssistStartComp") !== "undefined") {
                let callBackFun = eval("window.SupportAssistStartComp");
                let returnObj = callBackFun.call(this, null);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.supportAssistFinish = () => {
            if (eval("typeof window.SupportAssistFinishComp") !== "undefined") {
                let callBackFun = eval("window.SupportAssistFinishComp");
                let returnObj = callBackFun.call(this, null);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.Url = () => {
            if (Dell.OnlineUtils !== 'undefined' && Dell.OnlineUtils.Lwp !== 'undefined') {
                let baseUrl = 'https://www.dell.com/support/components';
                if (Dell.ComponentLoader.baseUrls !== undefined && Dell.ComponentLoader.baseUrls["DetectProductApi"]) {
                    baseUrl = Dell.ComponentLoader.baseUrls["DetectProductApi"];
                }
                let urls = {
                    baseUrl: baseUrl,
                    getCmsContent: 'detectproduct/cmstokensainfo?appName=' + Dell.ComponentLoader.appNames["detect-product"],
                    getProductInfo: 'detectproduct/productinfo'
                };
                return urls;
            }
            return '';
        };

        this.IsSaSupportedOs = () => {            
            let isSupportedOs = true;
            if (window.detectPcSaSupportedOs !== 'undefined') {
                isSupportedOs = window.detectPcSaSupportedOs;
            }
            return isSupportedOs;      
        };

        this.makeAjaxCall = (url, methodType) => {
            let ajaxData = {
                url: url,
                method: methodType,
                dataType: "json",
                contentType: "application/json;",
                cache: false,
                async: true
            };

            if (url.indexOf("//.dell.com") === -1) {
                ajaxData.xhrFields = {
                    withCredentials: true
                };
            }

            return jq.ajax(ajaxData);
        };

        var getProductInfoHtml1 = this.getProductInfoHtml;

        var getOsNotSupportedtHtml1 = this.getOsNotSupportedtHtml;
        var getnoSupportAssistHtml1 = this.getnoSupportAssistHtml;

        this.getProductInfo = (detectResponse) => {
            this.detectProductPromise.resolve(detectResponse);
            if (detectResponse.supportAssistInstalled) {
                let urlPath = this.Url();
                let saUrl = `${urlPath.baseUrl}/${urlPath.getProductInfo}/${detectResponse.serviceTag}/${Dell.ComponentLoader.appNames["detect-product"]}`;
                this.makeAjaxCall(saUrl, "GET")
                    .done(function (response) {
                        if (typeof (Storage) !== "undefined") {
                            sessionStorage.setItem("thispc", JSON.stringify(response.productInfo));
                        }
                        getProductInfoHtml1(response);
                    }).fail(function () {
                        console.error('detect product api failed');
                    });
            } else {
               
                var isSaSupportedOs = this.IsSaSupportedOs();                
                if (isSaSupportedOs !== undefined && !isSaSupportedOs) {
                            getOsNotSupportedtHtml1(detectProductContent);
                        } else {
                            getnoSupportAssistHtml1(detectProductContent);
                        }
                    
            }
        };

        let getProductInformation = this.getProductInfo;
        var supportAssistStart1 = this.supportAssistStart;

        this.callSupportAssist = (clientApi) => {
            let detectResponse = {};
            clientApi.findService(function () {
                    supportAssistStart1();
                    detectResponse = {
                        serviceTag: sessionStorage.getItem('tagFromSA'),
                        supportAssistInstalled: true
                    };
                    getProductInformation(detectResponse);
                },
                function () {
                    detectResponse = {
                        serviceTag: '',
                        supportAssistInstalled: false
                    };
                    getProductInformation(detectResponse);
                });
        };

        this.setSaToken = (globalObj, response) => {
            globalObj.tokenExpires.setValue(response.dsdToken.expiration);
            globalObj.isAliveToken.setValue(response.dsdToken.isAliveToken);
            globalObj.getClientSystemInfoToken.setValue(response.dsdToken.clientSystemInfoToken);
            this.callSupportAssist(globalObj);
        };

        let setSupportAssistToken = this.setSaToken;
        var detectProductPromise = this.detectProductPromise;
   
        this.callSa = () => {
            let urlPath = this.Url();
            let url = `${urlPath.baseUrl}/${urlPath.getCmsContent}`;
            this.makeAjaxCall(url, "GET")
                .done(function (response) {
                    detectProductContent = response.detectProductContent;
                    return response;
                }).done(function (response) {
                    if (response.productInfo !== null && response.productInfo.serviceTag !== null) {
                        if (typeof (Storage) !== "undefined") {
                            sessionStorage.setItem("thispc", JSON.stringify(response.productInfo));
                        }
                        supportAssistStart1();
                        let detectResponse = {
                            serviceTag: response.productInfo.serviceTag,
                            supportAssistInstalled: true
                        };
                        detectProductPromise.resolve(detectResponse);
                        getProductInfoHtml1(response);
                    } else {
                        try {
                            loadFile(response.dsdToken.supportAssistConfigUrl,
                                function () {
                                    loadFile(response.dsdToken.dsdApiUrl,
                                        function () {
                                            let globalEsc = new $.eSupportClientApi();
                                            setSupportAssistToken(globalEsc, response);
                                        });
                                });
                        } catch (ex) {
                            console.error("DetectPc Error :- ", ex);
                        }
                    }
                }).fail(function () {
                    console.error('detect product api failed');
                });
        };

        this.renderView = (htmlString) => {
            var divAutoDetectPc = document.getElementById("divAutoDetectPc");
            if (divAutoDetectPc !== undefined && divAutoDetectPc !== null) {
                divAutoDetectPc.innerHTML = htmlString;
            }
        };

    }).apply(dell.Components.DetectProduct);
})(jQuery, Dell = window.Dell || {});